export const SLICE = 'reportsCenter';

const SEARCH_REPORTS = `${SLICE}/SEARCH_REPORTS`;
export const SEARCH_REPORTS_REQUEST = `${SEARCH_REPORTS}_REQUEST`;
export const SEARCH_REPORTS_SUCCESS = `${SEARCH_REPORTS}_SUCCESS`;
export const SEARCH_REPORTS_FAILURE = `${SEARCH_REPORTS}_FAILURE`;

const DOWNLOAD_REPORT = `${SLICE}/DOWNLOAD_REPORT`;
export const DOWNLOAD_REPORT_REQUEST = `${DOWNLOAD_REPORT}_REQUEST`;
export const DOWNLOAD_REPORT_SUCCESS = `${DOWNLOAD_REPORT}_SUCCESS`;
export const DOWNLOAD_REPORT_FAILURE = `${DOWNLOAD_REPORT}_FAILURE`;

const GET_TERM_REPORT_CONFIGS = `${SLICE}/GET_TERM_REPORT_CONFIGS`;
export const GET_TERM_REPORT_CONFIGS_REQUEST = `${GET_TERM_REPORT_CONFIGS}_REQUEST`;
export const GET_TERM_REPORT_CONFIGS_SUCCESS = `${GET_TERM_REPORT_CONFIGS}_SUCCESS`;
export const GET_TERM_REPORT_CONFIGS_FAILURE = `${GET_TERM_REPORT_CONFIGS}_FAILURE`;

// LP Selection
export const SELECT_LP = `${SLICE}/SELECT_LP`;

export const SET_SEARCH_REPORTS_PAGE_SIZE = `${SLICE}/SET_SEARCH_REPORTS_PAGE_SIZE`;
export const SET_CURRENT_FOLDER_PATH = `${SLICE}/SET_CURRENT_FOLDER_PATH`;
export const SET_CURRENT_PAGE = `${SLICE}/SET_CURRENT_PAGE`;
export const RESET_IS_TRIGGER_SEARCH_REPORT = `${SLICE}/RESET_IS_TRIGGER_SEARCH_REPORT`;
export const SET_REPORT_SELECTION = `${SLICE}/SET_REPORT_SELECTION`;
export const SET_SORT_CRITERIA = `${SLICE}/SET_SORT_CRITERIA`;
export const RESET_REPORT_LIST = `${SLICE}/RESET_REPORT_LIST`;
export const SET_FILTER_SHEET_OPEN = `${SLICE}/SET_FILTER_SHEET_OPEN`;
export const SET_FILTERS = `${SLICE}/SET_FILTERS`;

const INITIATE_BULK_UPLOAD_FILES = `${SLICE}/INITIATE_BULK_UPLOAD_FILES`;
export const INITIATE_BULK_UPLOAD_FILES_REQUEST = `${INITIATE_BULK_UPLOAD_FILES}_REQUEST`;
export const INITIATE_BULK_UPLOAD_FILES_SUCCESS = `${INITIATE_BULK_UPLOAD_FILES}_SUCCESS`;
export const INITIATE_BULK_UPLOAD_FILES_FAILURE = `${INITIATE_BULK_UPLOAD_FILES}_FAILURE`;

const FILE_PARTS_UPLOAD = `${SLICE}/FILE_PARTS_UPLOAD`;
export const FILE_PARTS_UPLOAD_REQUEST = `${FILE_PARTS_UPLOAD}_REQUEST`;
export const FILE_PARTS_UPLOAD_SUCCESS = `${FILE_PARTS_UPLOAD}_SUCCESS`;
export const FILE_PARTS_UPLOAD_FAILURE = `${FILE_PARTS_UPLOAD}_FAILURE`;

const COMPLETE_BULK_UPLOAD_FILES = `${SLICE}/COMPLETE_BULK_UPLOAD_FILES`;
export const COMPLETE_BULK_UPLOAD_FILES_REQUEST = `${COMPLETE_BULK_UPLOAD_FILES}_REQUEST`;
export const COMPLETE_BULK_UPLOAD_FILES_SUCCESS = `${COMPLETE_BULK_UPLOAD_FILES}_SUCCESS`;
export const COMPLETE_BULK_UPLOAD_FILES_FAILURE = `${COMPLETE_BULK_UPLOAD_FILES}_FAILURE`;

export const RESET_BULK_FILES_PART_STATE = `${SLICE}/RESET_BULK_FILES_PART_STATE`;

const UPLOAD_FILE_FOLDER = `${SLICE}/UPLOAD_FILE_FOLDER`;
export const UPLOAD_FILE_FOLDER_REQUEST = `${UPLOAD_FILE_FOLDER}_REQUEST`;
export const UPLOAD_FILE_FOLDER_SUCCESS = `${UPLOAD_FILE_FOLDER}_SUCCESS`;
export const UPLOAD_FILE_FOLDER_FAILURE = `${UPLOAD_FILE_FOLDER}_FAILURE`;

const DELETE_REPORT = `${SLICE}/DELETE_REPORT`;
export const DELETE_REPORT_REQUEST = `${DELETE_REPORT}_REQUEST`;
export const DELETE_REPORT_SUCCESS = `${DELETE_REPORT}_SUCCESS`;
export const DELETE_REPORT_FAILURE = `${DELETE_REPORT}_FAILURE`;

const BULK_DOWNLOAD_REPORTS = `${SLICE}/BULK_DOWNLOAD_REPORTS`;
export const BULK_DOWNLOAD_REPORTS_REQUEST = `${BULK_DOWNLOAD_REPORTS}_REQUEST`;
export const BULK_DOWNLOAD_REPORTS_SUCCESS = `${BULK_DOWNLOAD_REPORTS}_SUCCESS`;
export const BULK_DOWNLOAD_REPORTS_FAILURE = `${BULK_DOWNLOAD_REPORTS}_FAILURE`;

const GENERATE_REPORT_ASYNC = `${SLICE}/GENERATE_REPORT_ASYNC`;
export const GENERATE_REPORT_ASYNC_REQUEST = `${GENERATE_REPORT_ASYNC}_REQUEST`;
export const GENERATE_REPORT_ASYNC_SUCCESS = `${GENERATE_REPORT_ASYNC}_SUCCESS`;
export const GENERATE_REPORT_ASYNC_FAILURE = `${GENERATE_REPORT_ASYNC}_FAILURE`;
export const RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC = `${SLICE}/RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC`;
export const PREVIEW_ENABLED = `${SLICE}/PREVIEW_ENABLED`;

const GENERATE_PRESIGNED_URL = `${SLICE}/GENERATE_PRESIGNED_URL`;
export const GENERATE_PRESIGNED_URL_REQUEST = `${GENERATE_PRESIGNED_URL}_REQUEST`;
export const GENERATE_PRESIGNED_URL_SUCCESS = `${GENERATE_PRESIGNED_URL}_SUCCESS`;
export const GENERATE_PRESIGNED_URL_FAILURE = `${GENERATE_PRESIGNED_URL}_FAILURE`;
export const SET_DDU_LIST = `${GENERATE_PRESIGNED_URL}_SET_DDU_LIST`;

const GET_DOWNLOAD_REPORT_URL = `${SLICE}/GET_DOWNLOAD_REPORT_URL`;
export const GET_DOWNLOAD_REPORT_URL_REQUEST = `${GET_DOWNLOAD_REPORT_URL}_REQUEST`;
export const GET_DOWNLOAD_REPORT_URL_SUCCESS = `${GET_DOWNLOAD_REPORT_URL}_SUCCESS`;
export const GET_DOWNLOAD_REPORT_URL_FAILURE = `${GET_DOWNLOAD_REPORT_URL}_FAILURE`;

const FETCH_DATA_FROM_PRESIGNED_URL = `${SLICE}/FETCH_DATA_FROM_PRESIGNED_URL`;
export const FETCH_DATA_FROM_PRESIGNED_URL_REQUEST = `${FETCH_DATA_FROM_PRESIGNED_URL}_REQUEST`;
export const FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS = `${FETCH_DATA_FROM_PRESIGNED_URL}_SUCCESS`;
export const FETCH_DATA_FROM_PRESIGNED_URL_FAILURE = `${FETCH_DATA_FROM_PRESIGNED_URL}_FAILURE`;

const GET_REPORT_DETAILS = `${SLICE}/GET_REPORT_DETAILS`;
export const GET_REPORT_DETAILS_REQUEST = `${GET_REPORT_DETAILS}_REQUEST`;
export const GET_REPORT_DETAILS_SUCCESS = `${GET_REPORT_DETAILS}_SUCCESS`;
export const GET_REPORT_DETAILS_FAILURE = `${GET_REPORT_DETAILS}_FAILURE`;
export const RESET_GET_REPORT_DETAILS = `${SLICE}/RESET_GET_REPORT_DETAILS`;

const GET_REPORT_DETAILS_POLLING = `GET_REPORT_DETAILS_POLLING`;
export const START_GET_REPORT_DETAILS_POLLING_REQUEST = `${SLICE}/START_${GET_REPORT_DETAILS_POLLING}_REQUEST`;
export const STOP_GET_REPORT_DETAILS_POLLING_REQUEST = `${SLICE}/STOP_${GET_REPORT_DETAILS_POLLING}_REQUEST`;

const APPROVE_REPORT = `${SLICE}/APPROVE_REPORT`;
export const APPROVE_REPORT_REQUEST = `${APPROVE_REPORT}_REQUEST`;
export const APPROVE_REPORT_SUCCESS = `${APPROVE_REPORT}_SUCCESS`;
export const APPROVE_REPORT_FAILURE = `${APPROVE_REPORT}_FAILURE`;

const REJECT_REPORT = `${SLICE}/REJECT_REPORT`;
export const REJECT_REPORT_REQUEST = `${REJECT_REPORT}_REQUEST`;
export const REJECT_REPORT_SUCCESS = `${REJECT_REPORT}_SUCCESS`;
export const REJECT_REPORT_FAILURE = `${REJECT_REPORT}_FAILURE`;

const GET_PRESIGNED_URL = `${SLICE}/GET_PRESIGNED_URL`;
export const GET_PRESIGNED_URL_REQUEST = `${GET_PRESIGNED_URL}_REQUEST`;
export const GET_PRESIGNED_URL_SUCCESS = `${GET_PRESIGNED_URL}_SUCCESS`;
export const GET_PRESIGNED_URL_FAILURE = `${GET_PRESIGNED_URL}_FAILURE`;
